import * as api from '@owl-nest/api-client/latest'

export const extraFields = ['labels'] as const

export type ExtraFields = (typeof extraFields)[number]

export type Fan = api.Fan<ExtraFields>
